{
  "es": {
    "session": {
      "error_internalserver": {
        "goback": "Volver",
        "subtitle": "Vaya, parece que se ha producido un error inesperado.",
        "title": "500"
      },
      "error_notfound": {
        "goback": "Volver",
        "subtitle": "Lo sentimos, no hemos podido encontrar la página que buscas.",
        "title": "404"
      },
      "expired": {
        "text": "Tu sesión ha caducado por inactividad. Por motivos de seguridad, debes iniciar sesión de nuevo. \n\nHaz clic en Aceptar para ir a la pantalla de inicio de sesión.",
        "title": "Sesión caducada"
      },
      "logout_impersonate": {
        "text": "Se ha iniciado un cierre de sesión durante la suplantación.",
        "title": "Suplantación detenida"
      },
      "noaccess": {
        "text": "Es posible que te afecte nuestra <b>actualización</b> más reciente: <p></p> <ul> <li>&nbsp;</li> <li><b>Los miembros del equipo y los colaboradores</b> ahora tienen acceso (e inician sesión) a través de <b>ziggu.app</b> (en lugar de <i>%company%</i>.ziggu.app)</li> <li>&nbsp;</li> <li><b>Los clientes</b> no se ven afectados y todavía pueden acceder a la plataforma a través de <b><i>%company%</i>.ziggu.app</b> </ul> <p>&nbsp;</p> <p>Al hacer clic en Aceptar, se te redirigirá a la página correspondiente.</p> <p>Si sigues teniendo problemas, contacta con nosotros.</p>",
        "title": "Vaya... parece que ya no tienes acceso a esta página."
      }
    }
  }
}
